import { connect } from 'react-redux'
import Wrapper from 'pages/legislation/Wrapper'
import { setLegislationActNodes } from 'redux/actions'

const mapStateToProps = state => ({
  flavour: state.layout.flavour,
  actIdMap: state.legislation.actIdMap,
  act: state.legislation.act
})

const mapDispatchToProps = dispatch => ({
  setLegislationActNodes: actNodes => dispatch(setLegislationActNodes(actNodes))
})

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)
